<template>
	<div class="mobile-menu">
		<ul>
			<li v-for="link in menu" :key="link.id">
				<template v-if="link.href">
					<button
						type="button"
						@click="navigate(link)"
						:class="[{ active: activeMenu(link.label) }]"
					>
						{{ link.label }}
					</button>
					<span class="border-bottom-mobile"></span>
				</template>
				<template v-else>
					<button
						type="button"
						@click="toggleSubmenu(link)"
						:class="[{ active: activeMenu(link.label) }]"
					>
						{{ link.label }}
						<img
							src="images/icons/chevron-down-green.svg"
							:class="[
								'float-right',
								{ active: link.subMenuShow },
							]"
						/>
					</button>
					<span class="border-bottom-mobile"></span>
					<transition name="mobile-menu">
						<ul v-if="link.subMenuShow" class="mobile-submenu">
							<li
								v-for="(subLink, i) in link.subMenu"
								:key="'Sub_' + i"
							>
								<span
									v-if="subLink.link === '/eLearning'"
									@click="navigate(subLink)"
									>{{ subLink.label }}</span
								>
								<a
									v-else
									:href="subLink.link"
									:target="targetBlank(subLink.link)"
									>{{ subLink.label }}</a
								>
							</li>
						</ul>
					</transition>
				</template>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	methods: {
		navigate(link) {
			this.$router.push(link.href);
			this.$store.dispatch('toggleMobileMenu', false);
			this.$nextTick(() => {
				if (
					link.attributes &&
					document.getElementById('DashboardSwiper')
				)
					document
						.getElementById('DashboardSwiper')
						.swiper.slideTo(link.attributes.slideIndex, 300, false);
			});
		},
		toggleSubmenu(link) {
			link.subMenuShow = !link.subMenuShow;
		},
		activeMenu(link) {
			let active = false;
			switch (link) {
				case 'pulpit':
					active = this.$route.meta.title === 'Pulpit' ? true : false;
					break;
				case 'narzędzia inwestora':
					active =
						this.$route.meta.title === 'eLearning' ? true : false;
					break;
				default:
					active = false;
					break;
			}
			return active;
		},
		targetBlank(link) {
			return link === '/eLearning' ? '_self' : '_blank';
		},
		toggle() {
			if (this.mobileMenu) {
				this.$store.dispatch('toggleMobileMenu', false);
				this.$store.dispatch('closeSubMenu');
			} else {
				this.$store.dispatch('toggleMobileMenu', true);
			}
		},
	},
	computed: {
		menu() {
			return this.$store.getters.getMenu;
		},
		mobileMenu() {
			return this.$store.getters.getShowMobileMenu;
		},
	},
};
</script>
